(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rh-header-search"] && !Shopify.designMode) return;
  try {
    /* Opens the theme search modal and hands it the text, so its predictive search runs. */
  class RhHeaderSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.#placeholder();
      if (!this.hasAttribute('data-predictive')) return;
      if (!this.input) return;
      /* Mouse or touch: open on click, one tick later. The modal closes on any body click outside it
         (search-modal.js, onBodyClick), so opening on focus let the same click close it again.
         Keyboard: open on focus (Tab), where no click follows. */
      this.input.addEventListener('pointerdown', () => { this.pointer = true; });
      this.input.addEventListener('focus', () => { if (!this.pointer) this.#handOff(); });
      this.input.addEventListener('blur', () => { this.pointer = false; });
      this.input.addEventListener('click', () => {
        this.pointer = false;
        setTimeout(() => this.#handOff());
      });
      this.input.addEventListener('input', this.#handOff.bind(this));
    }

    /* Phones (under 750px) get the shorter placeholder, as in the mockup. */
    #placeholder() {
      const short = this.dataset.placeholderShort;
      if (!this.input || !short || !window.matchMedia) return;
      const full = this.input.placeholder;
      const phone = window.matchMedia('(max-width: 749px)');
      const apply = () => { this.input.placeholder = phone.matches ? short : full; };
      apply();
      phone.addEventListener?.('change', apply);
    }

    #handOff() {
      const modal = document.querySelector('.rh-header-search__modal');
      const target = modal?.querySelector('.search-modal input[type="search"]');
      if (!modal || !target || typeof modal.open !== 'function') return;
      if (modal.querySelector('details')?.hasAttribute('open')) {
        target.focus();
        return;
      }

      target.value = this.input.value;
      this.input.value = '';
      modal.open();
      this.#dock(modal);
      target.focus();
      target.dispatchEvent(new Event('input', { bubbles: true }));
    }

    /* The modal's own field sits on top of this field while the modal is open, so the header field
       looks like the search input and the results open under the header (assets/rh-home.css,
       body.rh-search-docked). The header turns solid (is-hover, as when a menu is open). */
    #dock(modal) {
      const root = document.documentElement.style;
      const header = document.querySelector('.shopify-section-header');
      const place = () => {
        const r = this.getBoundingClientRect();
        root.setProperty('--rh-dock-top', `${r.top}px`);
        root.setProperty('--rh-dock-left', `${r.left}px`);
        root.setProperty('--rh-dock-width', `${r.width}px`);
        root.setProperty('--rh-dock-height', `${r.height}px`);
      };
      place();
      document.body.classList.add('rh-search-docked');
      this.addedHover = !!header && !header.classList.contains('is-hover');
      if (this.addedHover) header.classList.add('is-hover');

      const onMove = () => requestAnimationFrame(place);
      window.addEventListener('resize', onMove);
      window.addEventListener('scroll', onMove, { passive: true });
      const onClose = () => {
        /* Escape or "Close search" (focus still in the panel): focus goes back to the header field, not to the
           page start. Not after a click outside the panel, and not on touch screens (the keyboard would open). */
        const returnFocus = modal.contains(document.activeElement) && !window.matchMedia('(pointer: coarse)').matches;
        document.body.classList.remove('rh-search-docked');
        if (this.addedHover) header?.classList.remove('is-hover');
        window.removeEventListener('resize', onMove);
        window.removeEventListener('scroll', onMove);
        if (returnFocus) {
          this.pointer = true; /* This focus must not open the panel again (see the focus listener). */
          this.input.focus({ preventScroll: true });
        }
      };
      document.addEventListener('searchmodal:close', onClose, { once: true });

      if (!RhHeaderSearch.closeBound) {
        RhHeaderSearch.closeBound = true;
        document.addEventListener('click', (event) => {
          if (event.target.closest('.rh-search-close')) document.querySelector('.rh-header-search__modal')?.close();
        });
      }
    }
  }

  if (!customElements.get('rh-header-search')) customElements.define('rh-header-search', RhHeaderSearch);
  } catch(e) { console.error(e); }
})();

})();
